import { ElementType } from 'react';

import {
  IcAndroidIcon,
  IcGlobeIcon,
  IcIosIcon,
  IcMonitorIcon,
  IcBlockIcon,
  IcPendingIcon,
} from '@gem/icons';

import { DevicePlatform, DeviceStatus } from '../Device.types';

interface IDeviceIconPresenterParams {
  platform: DevicePlatform;
  status?: DeviceStatus;
}

interface IDeviceIconPresenter {
  platformIcon: ElementType;
  statusIcon: ElementType | null;
}

export function useDeviceIconPresenter(params: IDeviceIconPresenterParams): IDeviceIconPresenter {
  const { platform, status } = params;

  const presenter: IDeviceIconPresenter = {
    get platformIcon(): ElementType {
      switch (platform) {
        case DevicePlatform.Web:
          return IcGlobeIcon;
        case DevicePlatform.Ios:
          return IcIosIcon;
        case DevicePlatform.Android:
        case DevicePlatform.Huawei:
          return IcAndroidIcon;
        case DevicePlatform.Desktop:
        case DevicePlatform.Other:
        default:
          return IcMonitorIcon;
      }
    },

    get statusIcon(): ElementType | null {
      switch (status) {
        case DeviceStatus.Pending:
          return IcPendingIcon;
        case DeviceStatus.Blocked:
          return IcBlockIcon;
        default:
          return null;
      }
    },
  };

  return presenter;
}
